const API_BASE = import.meta.env.VITE_API_URL || 'https://oyster-app-rm48i.ondigitalocean.app'
const STARS_PER_TICKET = 240

export function calculateStars(ticketCount: number): number {
  return ticketCount * STARS_PER_TICKET
}

export function formatStars(stars: number): string {
  return `${stars} ⭐`
}

export interface StarsPaymentResult {
  success: boolean
  transactionId?: string
  error?: string
}

export async function invokeStarsPayment(
  ticketCount: number,
  chatId: number
): Promise<StarsPaymentResult> {
  console.log('[STARS] invokeStarsPayment called:', { ticketCount, chatId })
  
  const tg = window.Telegram?.WebApp
  console.log('[STARS] Telegram WebApp:', tg ? 'EXISTS' : 'NOT FOUND')
  
  if (!tg) {
    console.log('[DEV] Simulating Stars payment:', { ticketCount })
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true, transactionId: `dev_${Date.now()}` })
      }, 1000)
    })
  }

  try {
    const url = `${API_BASE}/api/create-invoice`
    console.log('[STARS] Fetching:', url)
    
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ chatId, ticketCount }),
    })
    
    console.log('[STARS] Response status:', response.status)
    const data = await response.json()
    console.log('[STARS] Response data:', data)

    if (!data.success || !data.invoiceLink) {
      return { success: false, error: data.message || data.error || 'Failed to create invoice' }
    }

    console.log('[STARS] Opening invoice:', data.invoiceLink)
    console.log('[STARS] openInvoice method:', typeof tg.openInvoice)
    
    return new Promise((resolve) => {
      tg.openInvoice!(data.invoiceLink, (status: string) => {
        console.log('[STARS] Invoice callback status:', status)
        if (status === 'paid') {
          resolve({ success: true, transactionId: `tg_${Date.now()}` })
        } else {
          resolve({ success: false, error: status === 'cancelled' ? 'Payment cancelled' : `Payment failed: ${status}` })
        }
      })
    })
  } catch (error: any) {
    console.error('[STARS] Error:', error)
    return { success: false, error: error.message }
  }
}
